module.exports = __webpack_public_path__ + "static/img_1683-fe38ba2fe09efaad087d5d94a4a7b736.jpg";